module.exports = __webpack_public_path__ + "img/icon_map_8_on_011.9a21f8bb.png";